var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Box, IconButton, ListItem, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useFormDataReducer } from "../hooks/useFormDataReducer";
import { emailIsValid } from "../utils/virtusEmailValidator";
import { withForm, WithFormWithPrimarySecondaryButtons, WithFormWithSingleButton, } from "../utils/VTFormCreator";
import VTButton from "./VTButton";
import { useVirtusPasswordValidator } from "../hooks/useVirtusPasswordValidator";
import VisibilityRoundedIcon from "@mui/icons-material/VisibilityRounded";
import VisibilityOffRoundedIcon from "@mui/icons-material/VisibilityOffRounded";
import CheckCircleOutlineOutlinedIcon from "@mui/icons-material/CheckCircleOutlineOutlined";
import DoNotDisturbAltOutlinedIcon from "@mui/icons-material/DoNotDisturbAltOutlined";
import VTTextField from "./VTTextField";
function resetPasswordInputReducer(prevState, action) {
    switch (action.type) {
        case "email":
            return __assign(__assign({}, prevState), { email: action.payload });
        default:
            return prevState;
    }
}
function ResetPasswordInputs(_a) {
    var setFormData = _a.setFormData, inputFieldsProps = _a.inputFieldsProps;
    var _b = __read(useState({
        email: (inputFieldsProps === null || inputFieldsProps === void 0 ? void 0 : inputFieldsProps.initialEmailVal) ? inputFieldsProps === null || inputFieldsProps === void 0 ? void 0 : inputFieldsProps.initialEmailVal : "",
    }), 2), formDataObj = _b[0], setFormDataObj = _b[1];
    var setter = function (data) {
        setFormData(data);
        setFormDataObj(data);
    };
    var dispatch = useFormDataReducer(resetPasswordInputReducer, {
        email: (inputFieldsProps === null || inputFieldsProps === void 0 ? void 0 : inputFieldsProps.initialEmailVal) ? inputFieldsProps === null || inputFieldsProps === void 0 ? void 0 : inputFieldsProps.initialEmailVal : "",
    }, setter);
    var _c = __read(useState(false), 2), shouldDisplayEmailWarning = _c[0], setShouldDisplayEmailWarning = _c[1];
    var _d = __read(useState(false), 2), emailValid = _d[0], setEmailValid = _d[1];
    // useEffect(() => {
    //     if(inputFieldsProps?.initialEmailVal){
    //         dispatch({type: "email", payload: inputFieldsProps.initialEmailVal})
    //     }
    //     // emailValidCheck();
    // }, []);
    useEffect(function () {
        var initialEmailVal = (inputFieldsProps === null || inputFieldsProps === void 0 ? void 0 : inputFieldsProps.initialEmailVal) ? inputFieldsProps === null || inputFieldsProps === void 0 ? void 0 : inputFieldsProps.initialEmailVal : "";
        (inputFieldsProps === null || inputFieldsProps === void 0 ? void 0 : inputFieldsProps.onEmailChange) && inputFieldsProps.onEmailChange(initialEmailVal);
        emailValidCheck(initialEmailVal);
    }, [inputFieldsProps === null || inputFieldsProps === void 0 ? void 0 : inputFieldsProps.initialEmailVal]);
    function emailValidCheck(email) {
        var emailIsValidCheck = emailIsValid(email);
        setEmailValid(emailIsValidCheck);
    }
    return (_jsx(Box, __assign({ component: "div", sx: { height: "110px" } }, { children: _jsx(VTTextField, { type: "email", autoFocus: true, controlType: "non-controlled", value: (inputFieldsProps === null || inputFieldsProps === void 0 ? void 0 : inputFieldsProps.initialEmailVal) ? inputFieldsProps.initialEmailVal : formDataObj.email, sx: { marginTop: "10px" }, title: "Email", placeholder: "email", onChange: function (val) {
                (inputFieldsProps === null || inputFieldsProps === void 0 ? void 0 : inputFieldsProps.onEmailChange) && inputFieldsProps.onEmailChange(val);
                dispatch({ type: "email", payload: val });
                emailValidCheck(val);
                if (shouldDisplayEmailWarning) {
                    setShouldDisplayEmailWarning(!emailValid && formDataObj.email.length > 0);
                }
            }, onBlur: function () {
                window.setTimeout(function () {
                    setShouldDisplayEmailWarning(!emailValid && formDataObj.email.length > 0);
                }, 150);
            }, onKeyDown: function (e) {
                if (e.key.toLowerCase() === "enter") {
                    window.setTimeout(function () {
                        setShouldDisplayEmailWarning(!emailValid && formDataObj.email.length > 0);
                    }, 150);
                }
            }, errorMessage: (inputFieldsProps === null || inputFieldsProps === void 0 ? void 0 : inputFieldsProps.errorMessage)
                ? inputFieldsProps.errorMessage
                : shouldDisplayEmailWarning
                    ? "must be a valid email"
                    : undefined }) })));
}
var FormWithResetPasswordInputFields = withForm(ResetPasswordInputs);
export var VTResetPasswordForm = WithFormWithPrimarySecondaryButtons(FormWithResetPasswordInputFields);
function loginInputReducer(prevState, action) {
    switch (action.type) {
        case "login":
            return __assign(__assign({}, prevState), { login: action.payload });
        case "password":
            return __assign(__assign({}, prevState), { password: action.payload });
        default:
            return prevState;
    }
}
function LoginInputs(_a) {
    var setFormData = _a.setFormData, inputFieldsProps = _a.inputFieldsProps;
    inputFieldsProps = __assign({ includePassword: true }, inputFieldsProps);
    var _b = __read(useState({
        login: "",
        password: "",
    }), 2), formDataObj = _b[0], setFormDataObj = _b[1];
    var setter = function (data) {
        setFormData(data);
        setFormDataObj(data);
        (inputFieldsProps === null || inputFieldsProps === void 0 ? void 0 : inputFieldsProps.onInputsChanged) && inputFieldsProps.onInputsChanged(data);
    };
    var dispatch = useFormDataReducer(loginInputReducer, { login: "", password: "" }, setter);
    var _c = __read(useState(false), 2), shouldDisplayEmailWarning = _c[0], setShouldDisplayEmailWarning = _c[1];
    var _d = __read(useState(false), 2), emailValid = _d[0], setEmailValid = _d[1];
    var _e = __read(useState(false), 2), showPassword = _e[0], setShowPassword = _e[1];
    return (_jsxs(Box, __assign({ component: "div", sx: __assign({}, ((inputFieldsProps === null || inputFieldsProps === void 0 ? void 0 : inputFieldsProps.includePassword) && { height: "225px" })) }, { children: [_jsx(Box, __assign({ component: "div", sx: { height: "100px" } }, { children: _jsx(VTTextField, { type: "email", autoFocus: true, controlType: "non-controlled", value: formDataObj.login, sx: { marginTop: "10px" }, title: "Email", placeholder: "email", onChange: function (val) {
                        dispatch({ type: "login", payload: val });
                        var emailIsValidCheck = emailIsValid(val);
                        setEmailValid(emailIsValidCheck);
                        if (emailIsValidCheck && shouldDisplayEmailWarning)
                            setShouldDisplayEmailWarning(false);
                    }, onBlur: function () {
                        window.setTimeout(function () {
                            setShouldDisplayEmailWarning(!emailValid && formDataObj.login.length > 0);
                        }, 150);
                    }, errorMessage: !(inputFieldsProps === null || inputFieldsProps === void 0 ? void 0 : inputFieldsProps.errorMessage)
                        ? shouldDisplayEmailWarning
                            ? "must be a valid email"
                            : undefined
                        : inputFieldsProps.includePassword
                            ? " "
                            : inputFieldsProps === null || inputFieldsProps === void 0 ? void 0 : inputFieldsProps.errorMessage, onKeyDown: function (e) {
                        if (e.key.toLowerCase() === "enter") {
                            setShouldDisplayEmailWarning(!emailValid);
                        }
                    } }) })), inputFieldsProps.includePassword && (_jsx(VTTextField, { controlType: "non-controlled", value: formDataObj.password, sx: { marginTop: "10px" }, title: "Password", type: showPassword ? "text" : "password", placeholder: "password", errorMessage: inputFieldsProps === null || inputFieldsProps === void 0 ? void 0 : inputFieldsProps.errorMessage, onChange: function (val) { return dispatch({ type: "password", payload: val }); }, onKeyDown: function (e) {
                    if (e.key.toLowerCase() === "enter") {
                        setShouldDisplayEmailWarning(!emailValid);
                    }
                }, endIcon: _jsx(IconButton, __assign({ sx: {
                        background: "none",
                        "&:hover": { background: "none" },
                    }, tabIndex: -1, onClick: function () {
                        setShowPassword(!showPassword);
                    } }, { children: showPassword ? _jsx(VisibilityOffRoundedIcon, {}) : _jsx(VisibilityRoundedIcon, {}) })) }))] })));
}
var FormWithLoginInputFields = withForm(LoginInputs);
export var VTLoginForm = WithFormWithPrimarySecondaryButtons(FormWithLoginInputFields);
export var VTDemoEmailForm = WithFormWithSingleButton(FormWithLoginInputFields);
function GeneralInputReducer(prevState, action) {
    switch (action.type) {
        case "textField1":
            return __assign(__assign({}, prevState), { textField1: action.payload });
        case "textField2":
            return __assign(__assign({}, prevState), { textField2: action.payload });
        default:
            return prevState;
    }
}
function GeneralInputs(_a) {
    var setFormData = _a.setFormData, inputFieldsProps = _a.inputFieldsProps;
    var _b = __read(useState({
        textField1: "",
        textField2: "",
    }), 2), formDataLocal = _b[0], setFormDataLocal = _b[1];
    useEffect(function () {
        setFormData(formDataLocal);
    }, [formDataLocal]);
    var dispatch = useFormDataReducer(GeneralInputReducer, formDataLocal, setFormDataLocal);
    return (_jsxs(Box, __assign({ component: "div", sx: {} }, { children: [_jsx(VTTextField, { autoFocus: true, controlType: "non-controlled", sx: { marginTop: "10px" }, value: formDataLocal.textField1, title: "input field 1", required: formDataLocal.textField1.length === 0, onChange: function (val) { return dispatch({ type: "textField1", payload: val }); } }), _jsx(VTTextField, { controlType: "non-controlled", sx: { marginTop: "10px" }, value: formDataLocal.textField2, title: "input field 2", required: formDataLocal.textField2.length === 0, onChange: function (val) { return dispatch({ type: "textField2", payload: val }); } })] })));
}
var FormWithGeneralInputFields = withForm(GeneralInputs);
export var VTInputFieldsFormSingleButton = WithFormWithSingleButton(FormWithGeneralInputFields);
export var VTInputFieldsFormWithPrimarySecondaryButtons = WithFormWithPrimarySecondaryButtons(FormWithGeneralInputFields);
function resetCodeInputFormReducer(prevState, action) {
    switch (action.type) {
        case "code":
            return __assign(__assign({}, prevState), { code: action.payload });
        case "codeIsValid":
            return __assign(__assign({}, prevState), { codeIsValid: action.payload });
        default:
            return prevState;
    }
}
function ResetCodeInputs(_a) {
    var setFormData = _a.setFormData, inputFieldsProps = _a.inputFieldsProps;
    var _b = __read(useState({
        code: "",
        codeIsValid: false,
    }), 2), formDataObj = _b[0], setFormDataObj = _b[1];
    var setter = function (data) {
        setFormData(data);
        setFormDataObj(data);
    };
    var dispatch = useFormDataReducer(resetCodeInputFormReducer, { code: "", codeIsValid: false }, setter);
    var _c = __read(useState(false), 2), shouldDisplayCodeNotValid = _c[0], setShouldDisplayCodeNotValid = _c[1];
    var _d = __read(useState(false), 2), codeValid = _d[0], setCodeValid = _d[1];
    return (_jsx(Box, __assign({ component: "div", sx: { height: "110px" } }, { children: _jsx(VTTextField, { autoFocus: true, controlType: "non-controlled", value: formDataObj.code, sx: { marginTop: "10px" }, title: "Code", placeholder: "code", onChange: function (val) {
                var codeValid = val.length === 6;
                dispatch({ type: "codeIsValid", payload: codeValid });
                dispatch({ type: "code", payload: val });
                setCodeValid(codeValid);
                (inputFieldsProps === null || inputFieldsProps === void 0 ? void 0 : inputFieldsProps.onChange) && inputFieldsProps.onChange(val);
            }, onBlur: function () {
                window.setTimeout(function () {
                    setShouldDisplayCodeNotValid(!codeValid);
                }, 150);
            }, onKeyDown: function (e) {
                // e.preventDefault();
                if (e.key.toLowerCase() === "enter") {
                    setShouldDisplayCodeNotValid(!codeValid);
                }
                else {
                    setShouldDisplayCodeNotValid(false);
                }
            }, errorMessage: inputFieldsProps && inputFieldsProps.wrongCodeErrorMessage
                ? inputFieldsProps.wrongCodeErrorMessage
                : shouldDisplayCodeNotValid && formDataObj.code.length > 0
                    ? "code not valid"
                    : undefined }) })));
}
var FormWithResetCodeInputField = withForm(ResetCodeInputs);
export var VTResetCodeForm = WithFormWithPrimarySecondaryButtons(FormWithResetCodeInputField);
export var VTResetCodeFormSingleButton = WithFormWithSingleButton(FormWithResetCodeInputField);
export function VTResetCodeFormWithResendMsg(_a) {
    var onSubmit = _a.onSubmit, onCancel = _a.onCancel, onResend = _a.onResend, _b = _a.displayResendContent, displayResendContent = _b === void 0 ? false : _b, wrongCodeErrorMessage = _a.wrongCodeErrorMessage, sx = _a.sx;
    return (_jsxs(Box, __assign({ component: "div", sx: __assign({ display: "flex", flexDirection: "column", alignItems: "center" }, sx) }, { children: [_jsx(VTResetCodeForm, { sx: { width: "100%" }, primaryButtonText: "submit", secondaryButtonText: "cancel", onSecondaryButtonClicked: onCancel, title: "Reset Password", onSubmit: onSubmit, inputFieldsProps: {
                    wrongCodeErrorMessage: wrongCodeErrorMessage,
                } }), displayResendContent && (_jsxs(_Fragment, { children: [_jsx(Typography, __assign({ sx: { marginTop: "20px" }, variant: "body2", align: "center" }, { children: "you should have recieved an email" })), _jsx(VTButton, __assign({ sx: { marginTop: "15px", width: "100px" }, onClick: onResend, color: "primary" }, { children: "resend" }))] }))] })));
}
export function VTDemoEnterCode(_a) {
    var onSubmit = _a.onSubmit, onResend = _a.onResend, _b = _a.displayResendContent, displayResendContent = _b === void 0 ? true : _b, wrongCodeErrorMessage = _a.wrongCodeErrorMessage, sx = _a.sx;
    return (_jsxs(Box, __assign({ component: "div", sx: __assign({ display: "flex", flexDirection: "column", alignItems: "center" }, sx) }, { children: [_jsx(VTResetCodeFormSingleButton, { sx: { width: "100%" }, title: "Enter Confirmation Code", buttonText: "submit", singleButtonAlign: "center", onSubmit: onSubmit, inputFieldsProps: {
                    wrongCodeErrorMessage: wrongCodeErrorMessage,
                }, onButtonClick: function (formDataInputObj) {
                    // not needed for this
                } }), displayResendContent && (_jsxs(_Fragment, { children: [_jsx(Typography, __assign({ sx: { marginTop: "20px" }, variant: "body2", align: "center" }, { children: "check your emails for trial code" })), _jsx(VTButton, __assign({ sx: { marginTop: "15px", width: "100px" }, onClick: onResend, color: "primary" }, { children: "resend" }))] }))] })));
}
function PasswordRulesPassedAsListItems(_a) {
    var passwordRulesPassedObj = _a.passwordRulesPassedObj, size = _a.size;
    return (_jsx(Box, __assign({ component: "div" }, { children: Object.keys(passwordRulesPassedObj).map(function (ruleKey) {
            var ruleDidPass = passwordRulesPassedObj[ruleKey];
            return (_jsxs(ListItem, __assign({ sx: { margin: 0, padding: "2px" } }, { children: [ruleDidPass ? (_jsx(CheckCircleOutlineOutlinedIcon, { sx: {
                            marginRight: "10px",
                            color: "lime",
                            fontSize: "1.6em",
                        } })) : (_jsx(DoNotDisturbAltOutlinedIcon, { sx: {
                            marginRight: "10px",
                            color: "red",
                            fontSize: "1.6em",
                        } })), ruleKey] })));
        }) })));
}
function passwordConfirmInputFormReducer(prevState, action) {
    switch (action.type) {
        case "passwordA":
            return __assign(__assign({}, prevState), { passwordA: action.payload });
        case "passwordB":
            return __assign(__assign({}, prevState), { passwordB: action.payload });
        default:
            return prevState;
    }
}
function PasswordConfirmInputs(_a) {
    var setFormData = _a.setFormData, inputFieldsProps = _a.inputFieldsProps;
    var _b = __read(useState({
        passwordA: "",
        passwordB: "",
    }), 2), formDataObj = _b[0], setFormDataObj = _b[1];
    var setter = function (data) {
        setFormData(data);
        setFormDataObj(data);
    };
    var dispatch = useFormDataReducer(passwordConfirmInputFormReducer, { passwordA: "", passwordB: "" }, setter);
    var _c = __read(useVirtusPasswordValidator(formDataObj.passwordA), 4), passwordRulesPassedObj = _c[0], addRule = _c[1], removeRule = _c[2], doAllRulesPass = _c[3];
    var _d = __read(useState(false), 2), showPasswordA = _d[0], setShowPasswordA = _d[1];
    var _e = __read(useState(false), 2), showPasswordB = _e[0], setShowPasswordB = _e[1];
    return (_jsxs(Box, __assign({ component: "div", sx: { marginBottom: "20px" } }, { children: [_jsx(VTTextField, { autoFocus: true, controlType: "non-controlled", type: showPasswordA ? "text" : "password", value: formDataObj.passwordA, sx: { marginTop: "10px" }, title: "Password", placeholder: "password", infoHint: _jsxs(Box, __assign({ component: "div", sx: { padding: "10px" } }, { children: [_jsx(Typography, __assign({ variant: "subtitle1" }, { children: " password rules " })), _jsx(PasswordRulesPassedAsListItems, { passwordRulesPassedObj: passwordRulesPassedObj, size: "small" })] })), endIcon: _jsx(IconButton, __assign({ sx: {
                        background: "none",
                        "&:hover": { background: "none" },
                    }, tabIndex: -1, onClick: function () {
                        setShowPasswordA(!showPasswordA);
                    } }, { children: showPasswordA ? _jsx(VisibilityOffRoundedIcon, {}) : _jsx(VisibilityRoundedIcon, {}) })), onChange: function (val) {
                    dispatch({ type: "passwordA", payload: val });
                    inputFieldsProps && inputFieldsProps.onChangePasswordA && inputFieldsProps.onChangePasswordA(val);
                    //   const codeValid = val.length === 8;
                    //   setCodeValid(codeValid);
                    //   if (codeValid && shouldDisplayCodeNotValid)
                    //     setShouldDisplayCodeNotValid(false);
                }, onBlur: function () {
                    //   setShouldDisplayCodeNotValid(!codeValid);
                }, onKeyDown: function (e) {
                    if (e.key.toLowerCase() === "enter") {
                        // setShouldDisplayCodeNotValid(!codeValid);
                    }
                }, errorMessage: undefined }), _jsx(VTTextField, { controlType: "non-controlled", type: showPasswordB ? "text" : "password", value: formDataObj.passwordB, sx: { marginTop: "10px" }, title: "Confirm Password", placeholder: "confirm password", endIcon: _jsx(IconButton, __assign({ sx: {
                        background: "none",
                        "&:hover": { background: "none" },
                    }, tabIndex: -1, onClick: function () {
                        setShowPasswordB(!showPasswordB);
                    } }, { children: showPasswordB ? _jsx(VisibilityOffRoundedIcon, {}) : _jsx(VisibilityRoundedIcon, {}) })), onChange: function (val) {
                    dispatch({ type: "passwordB", payload: val });
                    inputFieldsProps && inputFieldsProps.onChangePasswordB && inputFieldsProps.onChangePasswordB(val);
                    //   const codeValid = val.length === 8;
                    //   setCodeValid(codeValid);
                    //   if (codeValid && shouldDisplayCodeNotValid)
                    //     setShouldDisplayCodeNotValid(false);
                }, onBlur: function () {
                    //   setShouldDisplayCodeNotValid(!codeValid);
                }, onKeyDown: function (e) {
                    if (e.key.toLowerCase() === "enter") {
                        // setShouldDisplayCodeNotValid(!codeValid);
                    }
                }, errorMessage: undefined })] })));
}
var FormWithConfirmPasswordInputFields = withForm(PasswordConfirmInputs);
export var VTConfirmPasswordForm = WithFormWithPrimarySecondaryButtons(FormWithConfirmPasswordInputFields);
export function VTConfirmPasswordFormWithdRulesWarning(_a) {
    var onSubmit = _a.onSubmit, onSecondaryButtonClicked = _a.onSecondaryButtonClicked, sx = _a.sx;
    var _b = __read(useState(""), 2), passwordA = _b[0], setPasswordA = _b[1];
    var _c = __read(useState(""), 2), passwordB = _c[0], setPasswordB = _c[1];
    var _d = __read(useState(false), 2), bothPasswordsMatch = _d[0], setBothPasswordsMatch = _d[1];
    useEffect(function () {
        setBothPasswordsMatch(passwordA === passwordB);
    }, [passwordA, passwordB]);
    var _e = __read(useState(false), 2), showPasswordRules = _e[0], setShowPasswordRules = _e[1];
    var _f = __read(useVirtusPasswordValidator(passwordA), 4), passwordRulesPassedObj = _f[0], addRule = _f[1], removeRule = _f[2], doAllRulesPass = _f[3];
    return (_jsxs(Box, __assign({ component: "div", sx: __assign({}, sx) }, { children: [_jsx(VTConfirmPasswordForm, { primaryButtonText: "submit", secondaryButtonText: "cancel", onSecondaryButtonClicked: function (formDataInputObj) {
                    onSecondaryButtonClicked();
                }, inputFieldsProps: {
                    onChangePasswordA: function (text) {
                        setPasswordA(text);
                    },
                    onChangePasswordB: function (text) {
                        setPasswordB(text);
                    },
                }, title: "New Password", onSubmit: function (formFieldsStateObject) {
                    setShowPasswordRules(true);
                    if (doAllRulesPass(formFieldsStateObject.passwordA) &&
                        formFieldsStateObject.passwordA === formFieldsStateObject.passwordB) {
                        onSubmit(true, formFieldsStateObject.passwordA);
                    }
                    else {
                        onSubmit(false);
                    }
                } }), showPasswordRules && (_jsxs(Box, __assign({ component: "div" }, { children: [_jsx(Typography, __assign({ sx: {
                            marginTop: "10px",
                            color: doAllRulesPass(passwordA) && bothPasswordsMatch ? "lime" : "red",
                        }, variant: "subtitle1" }, { children: !bothPasswordsMatch ? "passwords don't match" : "password rules" })), _jsx(PasswordRulesPassedAsListItems, { passwordRulesPassedObj: passwordRulesPassedObj, size: "large" })] })))] })));
}
